import React from 'react';
import './TeachersInfo.css'

const TeachersInfo = ({ teacher }) => {
     const { paragraph, job, img } = teacher;
     return (

          <div class="card shadow-lg p-3 rounded-4 mb-5 bg-body rounded m-3">


               <div class="mx-auto p-3 text-center">
                    <img className='info' src={img} alt="..." />
               </div>
               <div class="card-body text-center">
                    <h6 class="card-title">{job}</h6>
                    <p class="card-text">{paragraph}
                    </p>

               </div>

          </div>

     );
};

export default TeachersInfo;